var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-result',{attrs:{"status":"404","title":"抱歉，您访问的页面不存在"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push({path:'/'})}}},[_vm._v("返回首页")])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }